import logo from './logo.svg';
import './App.css';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme/theme';
import Router from './routes/routes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import BASE_URL from './common';
import { Getprofile } from './redux/authSlice';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

function App() {
  const dispatch=useDispatch()
  useEffect(() => {
    dispatch(Getprofile())
  },[dispatch])
  return (
    <div className="App">
      
      <ToastContainer />


      <ThemeProvider theme={theme}>
        <CssBaseline />
          <Router />
      </ThemeProvider>

    </div>
  );
}

export default App;
